import React from 'react'
import clsx from 'clsx'

import { ReactComponent as add } from 'assets/iconsNew/add.svg'
import { ReactComponent as api } from 'assets/iconsNew/api.svg'
import { ReactComponent as arrowUpOutline } from 'assets/iconsNew/arrow-up-outline.svg'
import { ReactComponent as arrowDownOutline } from 'assets/iconsNew/arrow-down-outline.svg'
import { ReactComponent as attacksIcon } from 'assets/iconsNew/attacks.svg'
import { ReactComponent as caretBack } from 'assets/iconsNew/caret-back.svg'
import { ReactComponent as caretDown } from 'assets/iconsNew/caret-down.svg'
import { ReactComponent as caretForward } from 'assets/iconsNew/caret-forward.svg'
import { ReactComponent as caretForwardCircle } from 'assets/iconsNew/caret-forward-circle.svg'
import { ReactComponent as caretNeutral } from 'assets/iconsNew/caret-neutral.svg'
import { ReactComponent as caretUp } from 'assets/iconsNew/caret-up.svg'
import { ReactComponent as checkmark } from 'assets/iconsNew/checkmark.svg'
import { ReactComponent as checkmarkDouble } from 'assets/iconsNew/checkmark-double.svg'
import { ReactComponent as chevronBack } from 'assets/iconsNew/chevron-back.svg'
import { ReactComponent as chevronDown } from 'assets/iconsNew/chevron-down.svg'
import { ReactComponent as chevronForward } from 'assets/iconsNew/chevron-forward.svg'
import { ReactComponent as chevronUp } from 'assets/iconsNew/chevron-up.svg'
import { ReactComponent as clients } from 'assets/iconsNew/clients.svg'
import { ReactComponent as close } from 'assets/iconsNew/close.svg'
import { ReactComponent as closeOctagonOutlineIcon } from 'assets/icons/close-octagon-outline.svg'
import { ReactComponent as company } from 'assets/iconsNew/company.svg'
import { ReactComponent as copy } from 'assets/iconsNew/copy.svg'
import { ReactComponent as cube } from 'assets/icons/cube.svg'
import { ReactComponent as docs } from 'assets/iconsNew/docs.svg'
import { ReactComponent as ellipsisHorizontal } from 'assets/iconsNew/ellipsis-horizontal.svg'
import { ReactComponent as ellipsisVertical } from 'assets/iconsNew/ellipsis-vertical.svg'
import { ReactComponent as edit } from 'assets/iconsNew/edit.svg'
import { ReactComponent as gremlinHeadLogo } from 'assets/gremlin-mascot.svg'
import { ReactComponent as grid } from 'assets/iconsNew/grid.svg'
import { ReactComponent as helm } from 'assets/iconsNew/helm.svg'
import { ReactComponent as info } from 'assets/iconsNew/info.svg'
import { ReactComponent as key } from 'assets/iconsNew/key.svg'
import { ReactComponent as trendingDown } from 'assets/iconsNew/trending-down.svg'
import { ReactComponent as trendingUp } from 'assets/iconsNew/trending-up.svg'
import { ReactComponent as lock } from 'assets/iconsNew/lock.svg'
import { ReactComponent as mascotReversedIcon } from 'assets/gremlin-mascot-reversed.svg'
import { ReactComponent as move } from 'assets/iconsNew/move.svg'
import { ReactComponent as navExperiment } from 'assets/experiments-nav.svg'
import { ReactComponent as power } from 'assets/iconsNew/power.svg'
import { ReactComponent as remove } from 'assets/iconsNew/remove.svg'
import { ReactComponent as report } from 'assets/iconsNew/report.svg'
import { ReactComponent as schedulesIcon } from 'assets/iconsNew/schedule.svg'
import { ReactComponent as search } from 'assets/iconsNew/search.svg'
import { ReactComponent as share } from 'assets/iconsNew/share.svg'
import { ReactComponent as stack } from 'assets/icons/stack.svg'
import { ReactComponent as eyeOff } from 'assets/iconsNew/eye-off.svg'
import { ReactComponent as eye } from 'assets/iconsNew/eye.svg'
import { ReactComponent as star } from 'assets/iconsNew/star.svg'
import { ReactComponent as starOutline } from 'assets/iconsNew/star-outline.svg'
import { ReactComponent as support } from 'assets/iconsNew/support.svg'
import { ReactComponent as targetIcon } from 'assets/targets.svg'
import { ReactComponent as trafficLight } from 'assets/icons/traffic-light.svg'
import { ReactComponent as unlock } from 'assets/iconsNew/unlock.svg'
import { ReactComponent as user } from 'assets/iconsNew/user.svg'
import { ReactComponent as users } from 'assets/iconsNew/users.svg'
import { ReactComponent as warning } from 'assets/iconsNew/warning.svg'
// Attacks
import { ReactComponent as blackhole } from 'assets/icons/args/blackhole-icon.svg'
import { ReactComponent as cpu } from 'assets/icons/args/cpu-icon.svg'
import { ReactComponent as disk } from 'assets/icons/args/disk-icon.svg'
import { ReactComponent as dns } from 'assets/icons/args/dns-icon.svg'
import { ReactComponent as io } from 'assets/icons/args/io-icon.svg'
import { ReactComponent as latency } from 'assets/icons/args/latency-icon.svg'
import { ReactComponent as memory } from 'assets/icons/args/memory-icon.svg'
import { ReactComponent as packetLoss } from 'assets/icons/args/packet_loss-icon.svg'
import { ReactComponent as processKiller } from 'assets/icons/args/process-icon.svg'
import { ReactComponent as shutdown } from 'assets/icons/args/shutdown-icon.svg'
import { ReactComponent as timeTravel } from 'assets/icons/args/time_travel-icon.svg'
// Attack Args
import { ReactComponent as blockCount } from 'assets/icons/args/block-count-icon.svg'
import { ReactComponent as BlockSize } from 'assets/icons/args/block-size-icon.svg'
import { ReactComponent as ThreadBomb } from 'assets/icons/args/thread-bomb-icon.svg'
import { ReactComponent as cores } from 'assets/icons/args/cores-icon.svg'
import { ReactComponent as corrupt } from 'assets/icons/args/corrupt-icon.svg'
import { ReactComponent as delay } from 'assets/icons/args/delay-icon.svg'
import { ReactComponent as device } from 'assets/icons/args/device-icon.svg'
import { ReactComponent as dir } from 'assets/icons/args/dir-icon.svg'
import { ReactComponent as fullMatch } from 'assets/icons/args/full-match-icon.svg'
import { ReactComponent as gigabytes } from 'assets/icons/args/gigabytes-icon.svg'
import { ReactComponent as host } from 'assets/icons/args/host-icon.svg'
import { ReactComponent as port } from 'assets/icons/args/port-icon.svg'
import { ReactComponent as ipaddress } from 'assets/icons/args/ipaddress-icon.svg'
import { ReactComponent as killChildren } from 'assets/icons/args/kill-children-icon.svg'
import { ReactComponent as length } from 'assets/icons/args/length-icon.svg'
import { ReactComponent as MB } from 'assets/icons/args/megabytes-icon.svg'
import { ReactComponent as mode } from 'assets/icons/args/mode-icon.svg'
import { ReactComponent as monitor } from 'assets/icons/args/monitor-icon.svg'
import { ReactComponent as newest } from 'assets/icons/args/newest-icon.svg'
import { ReactComponent as ntp } from 'assets/icons/args/ntp-icon.svg'
import { ReactComponent as offset } from 'assets/icons/args/offset-icon.svg'
import { ReactComponent as oldest } from 'assets/icons/args/oldest-icon.svg'
import { ReactComponent as percent } from 'assets/icons/args/percent-icon.svg'
import { ReactComponent as protocol } from 'assets/icons/args/protocol-icon.svg'
import { ReactComponent as reboot } from 'assets/icons/args/reboot-icon.svg'
import { ReactComponent as workers } from 'assets/icons/args/workers-icon.svg'
// Scenarios
import { ReactComponent as scenarios } from 'assets/iconsNew/scenarios.svg'
import { ReactComponent as checklist } from 'assets/icons/checklist.svg'
// Services
import { ReactComponent as services } from 'assets/icons/services.svg'
// Support
import { ReactComponent as cog } from 'assets/iconsNew/cog.svg'

const attacks = {
  blackhole,
  cpu,
  disk,
  dns,
  io,
  latency,
  memory,
  packetLoss,
  process_killer: processKiller,
  shutdown,
  time_travel: timeTravel
}

const args = {
  api,
  'all-cores': cores,
  'block-count': blockCount,
  'block-size': BlockSize,
  'thread-bomb': ThreadBomb,
  cores,
  corrupt,
  delay,
  device,
  dir,
  docs,
  egressPorts: port,
  egress_port: port,
  exact: dir,
  'full-match': fullMatch,
  full: fullMatch,
  gigabytes,
  group: users,
  host,
  hostname: port,
  ingressPorts: port,
  ingress_port: port,
  interval: delay,
  ipaddress,
  ipprotocol: protocol,
  'kill-children': killChildren,
  kill_children: killChildren,
  length,
  megabytes: MB,
  MB,
  mode,
  monitor,
  ms: delay,
  newest,
  ntp,
  offset,
  oldest,
  packet_loss: packetLoss,
  percent,
  process: processKiller,
  protocol,
  reboot,
  'source-ports': port,
  src_port: port,
  port,
  workers,
  user,
  volumePercentage: percent
}

const icons = {
  ...attacks,
  ...args,
  add,
  arrowUpOutline,
  arrowDownOutline,
  attacksIcon,
  caretBack,
  caretDown,
  caretForward,
  caretForwardCircle,
  caretNeutral,
  caretUp,
  checklist,
  checkmark,
  checkmarkDouble,
  chevronBack,
  chevronDown,
  chevronForward,
  chevronUp,
  clients,
  close,
  closeOctagonOutlineIcon,
  company,
  copy,
  cube,
  edit,
  ellipsisHorizontal,
  ellipsisVertical,
  eye,
  eyeOff,
  grid,
  gremlinHeadLogo,
  helm,
  info,
  trendingDown,
  trendingUp,
  mascotReversedIcon,
  move,
  navExperiment,
  power,
  remove,
  report,
  scenarios,
  schedulesIcon,
  search,
  services,
  share,
  stack,
  star,
  starOutline,
  support,
  targetIcon,
  trafficLight,
  lock,
  key,
  unlock,
  users,
  warning,
  cog
}

type IconProps = {
  icon: string
  className?: string
}

const filledIcons = [
  'edit',
  'ellipsisHorizontal',
  'ellipsisVertical',
  'info',
  'checkmark'
]

const Icon = React.forwardRef<
  React.Ref<any>,
  IconProps & React.HTMLAttributes<HTMLElement>
>(({ icon, className, ...rest }, ref) => {
  const IconComponent = icons[icon] || navExperiment

  // Check for icons that we want to use the thicker stroke-width from Ionicons with by default
  let fill = false

  if (filledIcons.includes(icon)) {
    fill = true
  }

  return (
    <IconComponent
      ref={ref}
      className={clsx('Icon', className)}
      css={[
        {
          shapeRendering: 'geometricPrecision'
        },

        !fill && {
          '[stroke-width]': {
            strokeWidth: 24
          }
        }
      ]}
      {...rest}
    />
  )
})

export default Icon
